module.exports = __webpack_public_path__ + "static/media/proj_3.b86f51e0.png";